var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useAtomValue } from "jotai";
import cssInputLookAndFeel from "@/atoms/css-input-look-and-feel";
var StyledApp = styled(Box, {
    shouldForwardProp: function (prop) { return prop !== "customCss"; },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"
    /** Applies the tenant's look-and-feel CSS to its children. */
])), function (_a) {
    var customCss = _a.customCss;
    return customCss;
});
/** Applies the tenant's look-and-feel CSS to its children. */
export var StyledAppAtom = function (_a) {
    var children = _a.children;
    var css = useAtomValue(cssInputLookAndFeel);
    return (_jsx(StyledApp, { className: "styled-app-atom", customCss: css, children: children }));
};
var templateObject_1;
